export enum SexEnum {
    HOMBRE= 1,
    MUJER= 2,

}
